import { create } from 'zustand';
import { SegmentProps } from '@/components/wallets-section/types';
import { segment, unUsableSegment, voucherBaseType, zeroBalanceSegment } from '@/services/models/api.models';
import { VouchersProps } from '@/components/vouchers-section/types';
interface ChooseValidate {
  lastSelectedSegment: segment | null,
  lastSelectedVoucher: voucherBaseType | null,
  responseCode: number,
  responseMessage: string | null,
  unCombinationSegments: segment[],
  unCombinationVouchers: voucherBaseType[]
}
interface UserWalletsStore {
  refetchSegments: boolean;
  isSegmentLoading: boolean;
  invoice: number;
  maximumConcurrentUseCount: number;
  setInvoice: (arg: number) => void;
  segments: SegmentProps[]
  unusableSegments: unUsableSegment[]
  zeroBalanceSegments: zeroBalanceSegment[]
  setSegments: (arg: SegmentProps[]) => void;
  setUnusableSegments: (arg: unUsableSegment[]) => void;
  setZeroBalanceSegments: (arg: zeroBalanceSegment[]) => void;
  usableClientVouchers: VouchersProps[];
  unUsableVoucherAcceptorMerchants: voucherBaseType[];
  unUsableVoucherMinimumInvoiceAmounts: voucherBaseType[];
  unUsableVoucherPermissionItems: voucherBaseType[];
  setUsableClientVouchers: (arg: VouchersProps[]) => void;
  setUnUsableVoucherAcceptorMerchants: (arg: voucherBaseType[]) => void;
  setUnUsableVoucherMinimumInvoiceAmounts: (arg: voucherBaseType[]) => void;
  setUnUsableVoucherPermissionItems: (arg: voucherBaseType[]) => void;
  setIsSegmentLoading: (arg: boolean) => void;
  setRefetchSegments: (arg: boolean) => void;
  chooseValidate: {
    lastSelectedSegment: segment | null,
    lastSelectedVoucher: voucherBaseType | null,
    responseCode: number,
    responseMessage: string | null,
    unCombinationSegments: segment[],
    unCombinationVouchers: voucherBaseType[]
  };
  setChooseValidate: (arg: ChooseValidate) => void;
  setMaximumConcurrentUseCount: (arg: number) => void;
}

const useUserWalletsVouchersStore = create<UserWalletsStore>((set, get) => ({
  refetchSegments: false,
  isSegmentLoading: true,
  invoice: 0,
  maximumConcurrentUseCount: 0,
  setInvoice: (arg: number) => set({ invoice: arg }),
  setIsSegmentLoading: (arg: boolean) => set({ isSegmentLoading: arg }),
  setRefetchSegments: (arg: boolean) => set({ refetchSegments: arg }),
  segments: [],
  unusableSegments: [],
  zeroBalanceSegments: [],
  setSegments: (arg: SegmentProps[]) => set({ segments: arg }),
  setUnusableSegments: (arg: unUsableSegment[]) => set({ unusableSegments: arg }),
  setZeroBalanceSegments: (arg: zeroBalanceSegment[]) => set({ zeroBalanceSegments: arg }),
  usableClientVouchers: [],
  unUsableVoucherAcceptorMerchants: [],
  unUsableVoucherMinimumInvoiceAmounts: [],
  unUsableVoucherPermissionItems: [],
  setUsableClientVouchers:(arg: VouchersProps[]) => set({usableClientVouchers:arg}),
  setUnUsableVoucherAcceptorMerchants:(arg: voucherBaseType[]) => set({unUsableVoucherAcceptorMerchants:arg}),
  setUnUsableVoucherMinimumInvoiceAmounts:(arg: voucherBaseType[]) => set({unUsableVoucherMinimumInvoiceAmounts:arg}),
  setUnUsableVoucherPermissionItems:(arg: voucherBaseType[]) => set({unUsableVoucherPermissionItems:arg}),
  chooseValidate: {
    lastSelectedSegment: null,
    lastSelectedVoucher: null,
    responseCode: 0,
    responseMessage:  null,
    unCombinationSegments: [],
    unCombinationVouchers: []
  },
  setChooseValidate:(arg: ChooseValidate) => set({ chooseValidate: arg }),
  setMaximumConcurrentUseCount:(arg: number) => set({ maximumConcurrentUseCount: arg }),
}));
export default useUserWalletsVouchersStore;
